var React = require('react');

function Django (props) {
    return React.createElement("svg",props,[React.createElement("title",{"id":"django-logo-title","key":0},"Django logo"),React.createElement("path",{"d":"M64 64H0V0h64v64z","fill":"#092e21","key":1}),React.createElement("path",{"d":"M28.46 11h7.07v32.79a46.66 46.66 0 01-9.19 1c-8.63 0-13.14-3.9-13.14-11.39 0-7.21 4.78-11.9 12.17-11.9a11.33 11.33 0 013.08.37V11zm0 16.48a7 7 0 00-2.39-.37c-3.58 0-5.65 2.2-5.65 6.06s2 5.83 5.6 5.83a16.55 16.55 0 002.43-.18V27.53z","fill":"#fff","key":2}),React.createElement("path",{"d":"M46.79 22v16.4c0 5.65-.41 8.36-1.65 10.7s-2.66 3.67-5.79 5.24l-6.57-3.12c3.12-1.47 4.64-2.75 5.6-4.73s1.33-4.36 1.33-10.52V22h7.07zm-7.08-10.92h7.07v7.26h-7.07v-7.26z","fill":"#fff","key":3})]);
}

Django.defaultProps = {"viewBox":"0 0 64 64","aria-labelledby":"django-logo-title"};

module.exports = Django;

Django.default = Django;
